export interface IScriptsResponse {
  scriptGenerationIdentifier: string,
  scriptVerbiage: string,
}

export class ScriptsResponse implements IScriptsResponse {
  scriptGenerationIdentifier: string;
  scriptVerbiage: string;
}